'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CatButton } from '@blocks-react/components/Button';
import { CatIconCloseCircle } from '@blocks-react/components/Icons/CloseCircle';
import { useFormContext } from 'react-hook-form';
export const DealerLocatorFiltersClearServiceOfferingsButton = ({ children }) => {
    const { reset } = useFormContext();
    const clearFilters = () => {
        reset();
    };
    return (_jsxs(CatButton, { className: "ps-0", onClick: clearFilters, variant: "ghost", children: [children, _jsx(CatIconCloseCircle, { slot: "after" })] }));
};
